/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_EventsInputs */

const th_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการของคุณ`)
};

const en_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your events`)
};

const ja_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたの大会`)
};

const zh_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的赛事`)
};

const es_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus eventos`)
};

const pt_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus eventos`)
};

const id_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara Anda`)
};

const fr_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos événements`)
};

const tl_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang mga event mo`)
};

const vi_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sự kiện của bạn`)
};

const ko_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 이벤트`)
};

const de_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Events`)
};

const ru_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши события`)
};

const tr_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlikleriniz`)
};

const it_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi eventi`)
};

const pl_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje wydarzenia`)
};

const uk_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваші події`)
};

const hi_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपके आयोजन`)
};

const ar_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فعالياتك`)
};

const ms_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acara anda`)
};

const bn_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার আয়োজন`)
};

const zh_tw2_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的賽事`)
};

const zh_hk2_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的賽事`)
};

const ur_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کے ایونٹ`)
};

const fa_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رویدادهای شما`)
};

const sw_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matukio yako`)
};

const nl_your_events = /** @type {(inputs: Your_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw evenementen`)
};

/**
* | output |
* | --- |
* | "Your events" |
*
* @param {Your_EventsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_events = /** @type {((inputs?: Your_EventsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_EventsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_your_events(inputs)
	if (locale === "ja") return ja_your_events(inputs)
	if (locale === "zh") return zh_your_events(inputs)
	if (locale === "es") return es_your_events(inputs)
	if (locale === "pt") return pt_your_events(inputs)
	if (locale === "id") return id_your_events(inputs)
	if (locale === "fr") return fr_your_events(inputs)
	if (locale === "tl") return tl_your_events(inputs)
	if (locale === "vi") return vi_your_events(inputs)
	if (locale === "ko") return ko_your_events(inputs)
	if (locale === "de") return de_your_events(inputs)
	if (locale === "ru") return ru_your_events(inputs)
	if (locale === "tr") return tr_your_events(inputs)
	if (locale === "it") return it_your_events(inputs)
	if (locale === "pl") return pl_your_events(inputs)
	if (locale === "uk") return uk_your_events(inputs)
	if (locale === "hi") return hi_your_events(inputs)
	if (locale === "ar") return ar_your_events(inputs)
	if (locale === "ms") return ms_your_events(inputs)
	if (locale === "bn") return bn_your_events(inputs)
	if (locale === "zh-TW") return zh_tw2_your_events(inputs)
	if (locale === "zh-HK") return zh_hk2_your_events(inputs)
	if (locale === "ur") return ur_your_events(inputs)
	if (locale === "fa") return fa_your_events(inputs)
	if (locale === "sw") return sw_your_events(inputs)
	if (locale === "nl") return nl_your_events(inputs)
	return en_your_events(inputs)
});